module.exports = __webpack_public_path__ + "static/img/WhtBrd-bars.f42abf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WhtBrd-bars.png
// module id = 2YVP
// module chunks = 1